"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _accessControl = _interopRequireDefault(require("settings-ui-sdk/app/containers/hoc/accessControl"));

var _AccessControl = require("../../constants/AccessControl");

var _default = (0, _accessControl.default)({
  read: _AccessControl.READ,
  write: _AccessControl.WRITE
});

exports.default = _default;
module.exports = exports.default;